export function tabsService() {
	const groups = document.querySelectorAll(".block-tabs-service");

	if (!groups.length) return;

	groups.forEach((group) => {

		const tabs = group.querySelectorAll(".tab-title-item");
		const contents = group.querySelectorAll(".tab-content-item");

		const activateTab = (index) => {

			tabs.forEach((tab) => {
				tab.classList.remove("active");
			});

			contents.forEach((content) => {
				content.classList.remove("active");
			});

			if (tabs[index]) {
				tabs[index].classList.add("active");
			}

			if (contents[index]) {
				contents[index].classList.add("active");
			}
		};

		tabs.forEach((tab, index) => {

			tab.addEventListener("click", () => {
				activateTab(index);
			});

			tab.addEventListener("mouseenter", () => {
				activateTab(index);
			});
		});
	});
}
